import React from 'react';
import OptinodeAILogo from './OptinodeAILogo';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-content">
          {/* How We Help Section */}
          <div className="footer-section">
            <h3 className="footer-section-title">How We Help</h3>
            <ul className="footer-links">
              <li>
                <a href="#warehouse-optimization" className="footer-link">
                  Warehouse Optimization
                </a>
              </li>
              <li>
                <a href="#inventory-management" className="footer-link">
                  Inventory Management
                </a>
              </li>
              <li>
                <a href="#demand-forecasting" className="footer-link">
                  Demand Forecasting
                </a>
              </li>
              <li>
                <a href="#supply-chain-analytics" className="footer-link">
                  Supply Chain Analytics
                </a>
              </li>
              <li>
                <a href="#sop-planning" className="footer-link">
                  S&OP Planning
                </a>
              </li>
              <li>
                <a href="#ai-insights" className="footer-link">
                  AI-Powered Insights
                </a>
              </li>
            </ul>
          </div>

          {/* About Company Section */}
          <div className="footer-section">
            <h3 className="footer-section-title">About Optinode AI</h3>
            <ul className="footer-links">
              <li>
                <a href="#about-us" className="footer-link">
                  About Us
                </a>
              </li>
              <li>
                <a href="#our-mission" className="footer-link">
                  Our Mission
                </a>
              </li>
              <li>
                <a href="#careers" className="footer-link">
                  Careers
                </a>
              </li>
              <li>
                <a href="#contact" className="footer-link">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="#privacy-policy" className="footer-link">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#terms-of-service" className="footer-link">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media Section */}
          <div className="footer-section">
            <h3 className="footer-section-title">Connect With Us</h3>
            <div className="social-links">
              <a 
                href="https://linkedin.com/company/optinode-ai" 
                className="social-link"
                aria-label="Follow us on LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="social-icon">💼</span>
                <span className="social-text">LinkedIn</span>
              </a>
              <a 
                href="https://twitter.com/optinodeai" 
                className="social-link"
                aria-label="Follow us on Twitter"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="social-icon">🐦</span>
                <span className="social-text">Twitter</span>
              </a>
              <a 
                href="https://github.com/optinode-ai" 
                className="social-link"
                aria-label="View our GitHub"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="social-icon">💻</span>
                <span className="social-text">GitHub</span>
              </a>
              <a 
                href="https://youtube.com/@optinodeai" 
                className="social-link"
                aria-label="Subscribe to our YouTube channel"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="social-icon">📺</span>
                <span className="social-text">YouTube</span>
              </a>
            </div>
            
            {/* Newsletter Signup */}
            <div className="newsletter-section">
              <h4 className="newsletter-title">Stay Updated</h4>
              <p className="newsletter-description">
                Get the latest insights on warehouse optimization and AI-driven supply chain solutions.
              </p>
              <div className="newsletter-form">
                <input 
                  type="email" 
                  placeholder="Enter your email"
                  className="newsletter-input"
                  aria-label="Email address for newsletter"
                />
                <button 
                  type="button" 
                  className="newsletter-button"
                  onClick={() => alert('Newsletter signup coming soon!')}
                >
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="footer-brand">
              <OptinodeAILogo width={40} height={40} className="footer-logo" />
              <span className="footer-brand-text">Optinode AI</span>
            </div>
            <div className="footer-copyright">
              <p>&copy; {new Date().getFullYear()} Optinode AI. All rights reserved.</p>
              <p className="footer-tagline">
                Transforming supply chains with intelligent optimization
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;